import * as React from 'react';
import DropDown from '../Dropdown';
import Gender from '../Gender';
import Nickname from '../Nickname';
import PromotedSection from '../PromotedSection';
import GeneratorContext from '../../GeneratorContext';
import * as Styled from '../../Generator.styled';

const GeneratorSection: React.FC = () => {
  const { isGenerated } = React.useContext(GeneratorContext);
  const context = React.useContext(GeneratorContext);

  return (
    <>
      <Styled.GeneratorHead>
        <Styled.NicknameGeneratorIcon />
        <DropDown />
      </Styled.GeneratorHead>
      <Styled.GenerateSection isHasTitle={isGenerated} isCopied={context.isCopied}>
        <Gender />
        <Nickname />
      </Styled.GenerateSection>
      <PromotedSection />
    </>
  );
};

export default GeneratorSection;
